// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Caml_obj = require("rescript/lib/js/caml_obj.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Form__Input = require("../../../uikit/reason/atoms/Form/Form__Input.bs.js");
var Form__Components = require("../../../reason/common/Form/Form__Components.bs.js");
var JsxRuntime = require("react/jsx-runtime");
var CssGrid = require("components/CssGrid");
var RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
var PropertyWizardRelayUtils = require("./PropertyWizardRelayUtils.bs.js");
var PropertyWizardFormRelay__Validators__Description = require("./PropertyWizardFormRelay__Validators__Description.bs.js");
var PropertyWizardRelayDescriptionWebsite_localDraft_graphql = require("../../../__generated__/PropertyWizardRelayDescriptionWebsite_localDraft_graphql.bs.js");

var convertFragment = PropertyWizardRelayDescriptionWebsite_localDraft_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertyWizardRelayDescriptionWebsite_localDraft_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(PropertyWizardRelayDescriptionWebsite_localDraft_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, PropertyWizardRelayDescriptionWebsite_localDraft_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(PropertyWizardRelayDescriptionWebsite_localDraft_graphql.node, convertFragment, fRef);
}

var DraftFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function PropertyWizardRelay__Description__Website(props) {
  var draft = use(props.draft);
  var websiteIsValid = PropertyWizardFormRelay__Validators__Description.Website.useIsValid(draft.fragmentRefs);
  var website = PropertyWizardRelayUtils.FormUtils.useFormControl({
        TAG: "DraftProperty",
        _0: (function (dp, value) {
            var newrecord = Caml_obj.obj_dup(dp);
            newrecord.website = value;
            return newrecord;
          })
      }, props.stepHasBeenTouched, draft.draftProperty.website, websiteIsValid);
  return JsxRuntime.jsxs(CssGrid.Cell, {
              width: 12,
              children: [
                JsxRuntime.jsx(Form__Input.make, {
                      labelText: "Website",
                      optionalText: "optional",
                      placeholderText: "https://www.123MainStreet.com",
                      onChange: (function ($$event) {
                          var text = $$event.currentTarget.value;
                          website.onChange(PropertyWizardRelayUtils.FormUtils.noneIfEmpty(text));
                        }),
                      onBlur: (function (param) {
                          website.onBlur();
                        }),
                      onFocus: (function (param) {
                          website.onFocus();
                        }),
                      status: website.status,
                      value: website.valueAsString
                    }),
                JsxRuntime.jsx(Form__Components.FieldError.make, {
                      valid: website.valid
                    })
              ]
            });
}

var Components;

var TextInputField;

var Cell;

var Validators;

var FormUtils;

var Elements;

var make = PropertyWizardRelay__Description__Website;

exports.Components = Components;
exports.TextInputField = TextInputField;
exports.Cell = Cell;
exports.Validators = Validators;
exports.FormUtils = FormUtils;
exports.Elements = Elements;
exports.DraftFragment = DraftFragment;
exports.make = make;
/* Form__Input Not a pure module */
